module.exports = __webpack_public_path__ + "img/k-for-business.beab365.png";